import { onMounted, onUnmounted } from "vue";
import { storeToRefs } from "pinia";
import { useMainStore } from "@/store";
import { getImageDataURL } from "@/utils/image";
import usePasteTextClipboardData from "./usePasteTextClipboardData";
import useCreateElement from "./useCreateElement";
import { getPptIdByUrl } from "@/utils/common";
import { uploadFile } from "@/api/combo";
import { uploadFileToOSS, getFileExtension } from "@/utils/uploadOss";
export default () => {
  const { editorAreaFocus, thumbnailsFocus, disableHotkeys, pptId } =
    storeToRefs(useMainStore());

  const { pasteTextClipboardData } = usePasteTextClipboardData();
  const { createImageElement } = useCreateElement();

  // 粘贴图片到幻灯片元素
  const pasteImageFile = async (imageFile: File) => {
    // const formData = new FormData();
    // formData.append("file", imageFile);
    let fileType = getFileExtension(imageFile.name);
    const fileRes: any = await uploadFileToOSS(
      "content",
      imageFile,
      2,
      fileType
    );
    const dataURL = fileRes.name;
    createImageElement(dataURL);
  };

  /**
   * 粘贴事件监听
   * @param e ClipboardEvent
   */
  const pasteListener = (e: ClipboardEvent) => {
    if (!editorAreaFocus.value && !thumbnailsFocus.value) return;
    if (disableHotkeys.value) return;

    if (!e.clipboardData) return;

    const clipboardDataItems = e.clipboardData.items;
    const clipboardDataFirstItem = clipboardDataItems[0];

    if (!clipboardDataFirstItem) return;

    // 如果剪贴板内有图片，优先尝试读取图片
    for (const item of clipboardDataItems) {
      if (item.kind === "file" && item.type.indexOf("image") !== -1) {
        const imageFile = item.getAsFile();
        if (imageFile) pasteImageFile(imageFile);
        return;
      }
    }

    // 如果剪贴板内没有图片，但有文字内容，尝试解析文字内容
    if (
      clipboardDataFirstItem.kind === "string" &&
      clipboardDataFirstItem.type === "text/plain"
    ) {
      clipboardDataFirstItem.getAsString((text) =>
        pasteTextClipboardData(text)
      );
    }
  };

  onMounted(() => {
    document.addEventListener("paste", pasteListener);
  });
  onUnmounted(() => {
    document.removeEventListener("paste", pasteListener);
  });
};
